// extracted by mini-css-extract-plugin
module.exports = {"bgLogOut":"App_bgLogOut__2mfAi","bgLogin":"App_bgLogin__1grdv"};